<template>
    <div>
        <v-row dense justify="center">
            <v-col sm="6" md="6">
                <v-autocomplete :items="inst_list" v-model="inst_data" item-text="name" label="Search Employee" dense
                    return-object rounded color="#0f2027" outlined class="ma-2 no-display" :loading="comp_load"
                    placeholder="Search by employee code or name"></v-autocomplete>
            </v-col>
        </v-row>
        <v-btn class="primary" @click="bulk">Print All Employee Icards</v-btn>
        <v-row justify="center" dense v-if="inst_data != null">
            <v-radio-group v-model="radios" mandatory row class="ma-2 no-display">
                <v-radio label="Both" value="both" color="#0f2027"></v-radio>
                <v-radio label="Front Copy" value="front" color="#0f2027"></v-radio>
                <v-radio label="Back Copy" value="back" color="#0f2027"></v-radio>
            </v-radio-group>
            <v-btn @click="icardGenerate()" class="button no-display">Check Icard Data</v-btn>
        </v-row>
        <v-row justify="center" dense v-if="inst_data != null">
            <v-btn class="no-display" @click="changeAuth">Change Authority</v-btn>
        </v-row>

        <v-btn class="primary" v-if="inst_data != null && icard_data != ''" @click="call">Proceed to print</v-btn>
        <v-row dense justify="center">

            <div class="card mr-5" v-if="icard_data != '' && radios == 'front'" style="width: 25rem">
                <div v-for="(icard_data, ind) in icard_data" class="icard-wrapper">
                    <img :src="icard_data.watermark" class="watermark-bg" />
                    <div class="content-layer">
                        <center v-if="icard_data.profile_photo_path">
                            <img :src="icard_data.profile_photo_path" class="profile-photo" />
                        </center>
                        <div class="pa-3 details text-center">
                            <h4 style="font-family: 'Times New Roman', Times, serif;">{{ icard_data.name }}</h4>
                        <h5 style="font-family: 'Times New Roman', Times, serif;">{{ icard_data.designation }}</h5>
                        <h4 style="font-family: 'Times New Roman', Times, serif;">Employee Code : {{ icard_data.emp_code }}</h4>
                            <div class="mt-3 mb-3" style="height: 2px;background-color: #f79e31;"></div>
                            <h2
                                style="color: #c23308;font-size: 25px; font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;">
                                {{
                                    icard_data.school_name }}</h2>
                        </div>
                    </div>
                </div>
            </div>
            <div id="print" class="card" v-if="icard_data != '' && radios == 'back'" style="width: 25rem">
                <div v-for="(icard_data, ind) in icard_data" class="icard-wrapper">
                    <img :src="icard_data.watermark_back" class="watermark-bg" />
                    <div class="content-layer2 print-font px-2">
                        <b class="colored-text">Qualification : </b><b>{{ icard_data.emp_qualification }}</b><br>
                        <b class="colored-text">Address : </b><b>{{ icard_data.emp_address }}</b><br>
                        <b class="colored-text">Mobile : </b><b>{{ icard_data.emp_contact }}</b><br>
                        <b class="colored-text">Email : </b><b>{{ icard_data.emp_email_official }}</b><br>
                        <b class="colored-text">D.O.B : </b><b>{{ icard_data.emp_dob }}</b><br>
                        <b class="colored-text">Blood Group : </b><b>{{ icard_data.emp_blood_group }}</b><br>

                        <div v-if="icard_data.is_principal">
                            <img style=" position: absolute;right: 5px;bottom: 70px;" :src="icard_data.director_sign" alt="sign"
                                width="80" height="40" />
                            <span style=" position: absolute;right: 25px;bottom: 45px;"><b>Secretary</b></span>
                            </div>
                            <div v-else>
                            <img style=" position: absolute;right: 5px;bottom: 70px;" :src="icard_data.sign" alt="sign"
                                width="80" height="40" />
                            <span style=" position: absolute;right: 25px;bottom: 45px;"><b>Principal</b></span>
                        </div>
                        <barcode style=" position: absolute; bottom: 40px;" height="40" width="1.6"
                            :value="icard_data.emp_code" displayValue="false">
                        </barcode>
                        <div class="end-div text-center">
                            SANJIVANI
                        </div>
                    </div>

                </div>
            </div>
        </v-row>
        <v-row dense justify="center" v-if="icard_data != '' && radios == 'both'">
            <div v-for="(icard_data, ind) in icard_data" class="icard-wrapper">
                <img :src="icard_data.watermark" class="watermark-bg" />
                <div class="content-layer">
                    <center v-if="icard_data.profile_photo_path">
                        <img :src="icard_data.profile_photo_path" class="profile-photo" />
                    </center>
                    <div class="pa-3 details text-center">
                        <h4 style="font-family: 'Times New Roman', Times, serif;">{{ icard_data.name }}</h4>
                        <h5 style="font-family: 'Times New Roman', Times, serif;">{{ icard_data.designation }}</h5>
                        <h4 style="font-family: 'Times New Roman', Times, serif;">Employee Code : {{ icard_data.emp_code }}</h4>
                        <div class="mt-3 mb-3" style="height: 2px;background-color: #f79e31;"></div>
                        <h2
                            style="color: #c23308; font-size: 25px; font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;">
                            {{
                                icard_data.school_name }}</h2>
                    </div>
                </div>
            </div>

            <div v-for="(icard_data, ind) in icard_data" class="icard-wrapper ml-10">
                <img :src="icard_data.watermark_back" class="watermark-bg" />
                <div class="content-layer2 print-font px-2">
                    <b class="colored-text">Qualification : </b><b>{{ icard_data.emp_qualification }}</b><br>
                    <b class="colored-text">Address : </b><b>{{ icard_data.emp_address }}</b><br>
                    <b class="colored-text">Mobile : </b><b>{{ icard_data.emp_contact }}</b><br>
                    <b class="colored-text">Email : </b><b>{{ icard_data.emp_email_official }}</b><br>
                    <b class="colored-text">D.O.B : </b><b>{{ icard_data.emp_dob }}</b><br>
                    <b class="colored-text">Blood Group : </b><b>{{ icard_data.emp_blood_group }}</b><br>

                    <div v-if="icard_data.is_principal">
                            <img style=" position: absolute;right: 5px;bottom: 70px;" :src="icard_data.director_sign" alt="sign"
                                width="80" height="40" />
                            <span style=" position: absolute;right: 25px;bottom: 45px;"><b>Secretary</b></span>
                            </div>
                            <div v-else>
                            <img style=" position: absolute;right: 5px;bottom: 70px;" :src="icard_data.sign" alt="sign"
                                width="80" height="40" />
                            <span style=" position: absolute;right: 25px;bottom: 45px;"><b>Principal</b></span>
                        </div>
                    <barcode style=" position: absolute; bottom: 40px;" height="40" width="1.6"
                        :value="icard_data.emp_code" displayValue="false">
                    </barcode>
                    <div class="end-div text-center">
                        SANJIVANI
                    </div>
                </div>
            </div>
        </v-row>
    </div>
</template>
<script>
import axios from "axios";
import VueBarcode from "vue-barcode";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
export default {
    components: {
        barcode: VueBarcode,
    },
    data: () => ({
        comp_load: false,
        inst_list: null,
        radios: null,
        inst_data: null,
        icard_data: [],
        authority: "Principal",
        authority_sign: null,
    }),
    mounted() {
        this.comp_load = true;
        this.inst_data = null;
        axios
            .post("/RoleManagement/getAllEmployee")
            .then((res) => {
                if (res.data.msg == "200") {
                    this.inst_list = res.data.inst_list;
                } else {
                    alert("Something went wrong!!!");
                }
            })
            .catch((error) => {
                alert("Something went wrong!!!");
            })
            .finally(() => {
                this.comp_load = false;
            });
    },
    methods: {
        bulk() {
            let routeData = this.$router.resolve({ name: "sanjivani-inst-bulk-card-print" });
            window.open(routeData.href, "_blank");
        },
        call() {
            localStorage.setItem("inst_data", JSON.stringify(this.inst_data));
            localStorage.setItem("authority", this.authority);
            let routeData = this.$router.resolve({ name: "sanjivani-inst-card-print" });
            window.open(routeData.href, "_blank");
        },
        changeAuth() {
            this.authority = "Director";
            this.icard_data[0].sign = this.authority_sign;
        },
        print() {
            this.$store.state.drawer = false;
            let that = this;
            window.onafterprint = function () {
                that.$store.state.drawer = true;
            };
            setTimeout(function () {
                window.print();
            }, 100);
        },

        icardGenerate() {
            const data = {
                inst_data: this.inst_data,
            };
            axios
                .post("/Icard/icardGenerate", data)
                .then((res) => {
                    this.authority = "Principal";
                    this.icard_data = res.data.icard_data;
                    this.authority_sign = res.data.icard_data[0].director_sign;
                })

                .catch((error) => {
                    console.log("Error", error);
                    alert("Something went wrong!!!");
                })
                .finally(() => {
                    this.comp_load = false;
                });
        },
    },
};
</script>
<style scoped>
.content-layer {
    position: absolute;
    top: 90px;
    left: 0;
    width: 100%;
    /* height: 100%; */
    z-index: 2;
}

.content-layer2 {
    position: absolute;
    top: 180px;
    left: 0;
    width: 100%;
    height: 60%;
    z-index: 2;
}

.end-div {
    position: absolute !important;
    bottom: -5px !important;
    z-index: 2;
    color: #eb7d01;
    margin-left: 50px;
    font-weight: 700;
    font-size: 40px;
    letter-spacing: 1px;
}

.print-font {
    font-size: 15px;
}

.colored-text {
    color: #eb7d00;
}

.icard-wrapper {
    position: relative;
    width: 325px;
    height: 488px;
}

.watermark-bg {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;
    object-fit: cover;
}

.profile-photo {
    width: 130px;
    height: 130px;
    /* object-fit: cover; */
    border-radius: 50%;
    border: 2px solid #f79d31;
}
</style>
